export const DDD_SHARE_THRESHOLD = 5;
export const DEFAULT_PER_PAGE = 10;
export const PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const EXPORT_LIMIT = 20;

export const PER_PAGE_SELECT_OPTIONS = PER_PAGE_OPTIONS.map((option) => ({
	value: option.toString(),
	title: option.toString(),
}));
